import React from 'react';
import { createPortal } from 'react-dom';
import PhoneVerificationSteps from './PhoneVerificationSteps';
import { AssetUrls } from 'config/assets';
import './MobileVerificationModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  currentPhone?: string | null;
  onVerificationSuccess?: () => void;
}

/**
 * Standalone phone-verification modal: a shell around PhoneVerificationSteps.
 * The steps themselves are shared with the Manage SMS Alerts modal, which
 * renders them inside its own chrome. Everything this shell owns — overlay,
 * header, close button, the 2s self-close on success — is what makes it the
 * standalone variant.
 */
const MobileVerificationModal: React.FC<Props> = ({
  isOpen,
  onClose,
  currentPhone,
  onVerificationSuccess
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="mobile-verification-modal-overlay" onClick={onClose}>
      <div className="mobile-verification-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mobile-verification-modal-header">
          <h2 className="mobile-verification-modal-title">
            {currentPhone ? 'Change Phone Number' : 'Verify Phone Number'}
          </h2>
          <button className="mobile-verification-close-button" onClick={onClose}>
            <img
              src={AssetUrls.icons.dropdowns.close}
              alt="Close"
              style={{ width: 16, height: 16 }}
            />
          </button>
        </div>

        <div className="mobile-verification-modal-body">
          <PhoneVerificationSteps
            isActive={isOpen}
            onCancel={onClose}
            currentPhone={currentPhone}
            // Callers here take no argument; the verified number is only needed
            // by hosts that keep rendering after success.
            onVerificationSuccess={() => onVerificationSuccess?.()}
          />
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default MobileVerificationModal;
